/**
 * Optimizely experiment to control gradual rolling out of `/v2/menus` endpoint usage,
 * which provides single menu week per request (instead of all three active menus).
 */
export const EXPERIMENT_KEY_SINGLE_MENU_API = 'kales_single_menu_api'
